module.exports = __webpack_public_path__ + "img/17.65824f0b.png";